
import { Component, Vue } from 'vue-property-decorator';
@Component<ReportPage>({})
export default class ReportPage extends Vue {}
